import "./InventoryHistory.css";
import IconX from "../../assets/images/x.svg";
import React, { useEffect, useRef, useState, useCallback } from "react";

import { getJsonPath, getBkendUrl } from "../../consts";
import axios_with_token from "../../axios_with_token";
import {Modal} from "bootstrap/dist/js/bootstrap.bundle.min.js";

import Tbl from "../../input_types/Tbl/Tbl";

// import ModalDlg from "../../input_types/ModalDlg/ModalDlg";
// import RcdEdit from "../../input_types/RcdEdit/RcdEdit";

import { useTbl, useChkRawData, randomUUID } from "../../axios_with_token";

import {useRcdEditDialog} from "../../input_types/Dialog/Dialog";

const jsonPath = getJsonPath();
const bkendUrl = getBkendUrl();

export default function InventoryHistory(props){
    return <div>
        inventory history
    </div>;
}